/*
 * Copyright (c) 2019, Ahmed Allem <ahmed.allem@gmail.com>
 *
 * License: MIT
 */

import React, { Component } from "react";

import { MegadraftPlugin, MegadraftIcons } from "megadraft";
const {BlockContent, BlockData, BlockInput, CommonBlock} = MegadraftPlugin;


export default class Block extends Component {
  constructor(props) {
    super(props);

    this._handleCaptionChange = this._handleCaptionChange.bind();
    this._handleRightsHolderChange = this._handleRightsHolderChange.bind();

    this.actions = [
      {
        key: "delete",
        icon: MegadraftIcons.DeleteIcon,
        action: this.props.container.remove
      }
    ];
  }

  _handleCaptionChange(event) {
    event.stopPropagation();
    this.props.container.updateData({ caption: event.target.value });
  }

  _handleRightsHolderChange(event) {
    event.stopPropagation();
    this.props.container.updateData({ rightsHolder: event.target.value });
  }

  render() {

    var ImageStyle = {
        display: "inline-block", // Eliminates whitespace between block and data fields block
        maxWidth: "100%",
        verticalAlign: "middle"
    }

    var image_size_type = this.props.data.display || 'medium';

    if(image_size_type === 'small'){
      ImageStyle = {...ImageStyle, width: "50%"};
    }
    else if(image_size_type === 'medium'){
      ImageStyle = {...ImageStyle, width: "80%"};
    }
    else if(image_size_type === 'big'){
      ImageStyle = {...ImageStyle, width: "100%"};
    }

    return (
      <CommonBlock {...this.props} actions={this.actions}>
        <BlockContent>
          <img style={ImageStyle} src={this.props.data.src}  alt="" />
        </BlockContent>
      </CommonBlock>
    );
  }
}
